// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ED-z","modalContent":"FD-z","header":"GD-z","close":"HD-z"};